import Ext from 'Ext'
import {makeHandler} from '../atUtils'

const CreateChartButton = Ext.extend(Ext.Container,
        {
            buttonText: "",
            clickAction: Ext.emptyFn,

            autoEl: "div",
            layout: "table",
            buttonClass: "graphicButton createChart button",
            hideOnResize: false,

            initComponent: function() {
                CreateChartButton.superclass.initComponent.call(this);
                this.baseButton = this.getBaseButton();
                this.add( this.baseButton.button );
            },

            mouseOver: function()
            {
                this.baseButton.hover();
            },

            mouseOut: function()
            {
                this.baseButton.reset();
            },

            afterRender: function() {
                this.baseButton.button.on("render", function()
                {
                    this.baseButton.defineStandardEventHandlers(false, false, true, true);
                    this.baseButton.button.el.on("mouseover", this.mouseOver, this);
                    this.baseButton.button.el.on("mouseout", this.mouseOut, this);
                    this.baseButton.button.el.on("click", this.baseButtonClick, this);
                }, this);
            },

            baseButtonClick: function()
            {
                this.baseButton.deactivate();
                this.clickAction(makeHandler(this.dialogHide, this));
            },

            dialogHide: function()
            {
                this.baseButton.reset();
            },

            getBaseButton: function() {
                return new GraphicButton(new AT.RectangularBox({
                    cls: this.buttonClass,
                    items: [{
                        xtype: "box",
                        autoEl: {
                            tag: "div",
                            html: "<div class='icon'></div><span unselectable='on'>" + this.buttonText + "</span>"
                        }
                    }]
                }));
            }
        });

export default CreateChartButton


// WEBPACK FOOTER //
// ./web/js/reports/at_create_chart_button.js